<template>
  <el-select
    v-model="selected"
    size="small"
    @change="handleChange"
    placeholder="选择仓库"
    style="width: 100%"
  >
    <el-option label="全部" value="" v-if="clearable"></el-option>
    <el-option
      v-for="item in lists"
      :key="item.id"
      :label="item.name"
      :value="item.id"
    ></el-option>
  </el-select>
</template>

<script>
import { stockroomList } from '@/service/getData'

export default {
  props: {
    val: '',
    clearable: {
      type: Boolean,
      default: true,
    },
  },
  watch: {
    val: function (v) {
      this.selected = v
    },
  },
  data() {
    return {
      selected: '',
      lists: [],
    }
  },
  created() {
    this.requestData()
  },
  methods: {
    handleChange() {
      this.$emit('change', this.selected)
    },
    async requestData() {
      let res = await stockroomList()
      if (res.status == 0) {
        this.lists = res.data.list || []
        this.selected = this.val
      }
    },
  },
}
</script>